import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgHydrocolloidBandageGlyph from './svgs/HydrocolloidBandageGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var hydrocolloidBandageGlyph = (props => useIcon(SvgHydrocolloidBandageGlyph, SvgHydrocolloidBandageGlyph, props));

export { hydrocolloidBandageGlyph as default };
